import React from 'react'
import DialogContent from '.'

export const dialogContentObj = {
  isCloseDialog: false,
  type: 'content',
  iconType: 'info',
  content: <DialogContent />,
}
